import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams } from "react-router-dom";
import {
  setDeliveryType,
  setPickupLocation,
  setPickupLock,
} from "../modules/delivery/actions";
import { DELIVERY_PICKUP } from "../modules/delivery/reducer";
import {
  forgetPickupLink,
  rememberPickupLink,
} from "../utils/pickupLinkSession";
import Frontpage from "./frontpage";

function PickupOrder() {
  const { hash } = useParams();
  const dispatch = useDispatch();
  const { name: storeName, pickupLocations } = useSelector(
    (state) => state.store
  );
  const pickupLocked = useSelector((state) => state.delivery.pickup_locked);
  const pickupLocation = pickupLocations.find(
    (location) => location.hash === hash
  );

  useEffect(() => {
    if (!pickupLocation) return undefined;

    rememberPickupLink(hash);
    dispatch(setDeliveryType(DELIVERY_PICKUP));
    dispatch(setPickupLocation(pickupLocation.id));
    dispatch(setPickupLock(true));

  }, [dispatch, hash, pickupLocation]);

  useEffect(() => {
    if (storeName && !pickupLocation) {
      forgetPickupLink();
      dispatch(setPickupLock(false));
    }
  }, [dispatch, pickupLocation, storeName]);

  if (!storeName) {
    return null;
  }

  if (!pickupLocation) {
    return <Redirect to="/" replace />;
  }

  if (pickupLocation && !pickupLocked) {
    return null;
  }

  return <Frontpage />;
}

export default PickupOrder;
